<template>
  <div class="page">
    <img src="../../assets/images/acmedback.png" class="topimg" alt="" />
    <div class="totle">
      <div class="titletext">
        您的信息已录入
      </div>
      <div class="titlebtn" @click="goToUpload()">
        <div class="iconout"><img src="../../assets/images/enterinicon.png" alt="" class="btnicon"></div>
        <div class="btntext">请点击进入申请流程</div>
      </div>
      <div class="qrcode">
        <img src="../../assets/images/enterincode.png" class="okqrcode1" alt="" />
      </div>
    </div>
    <!-- <div class="backbtn" @click="back()">返回</div> -->
  </div>
</template>

<script>
export default {
  components: {},
  name: "uploadInfo",
  data() {
    return {};
  },
  computed: {},
  created() {
    document.title = "加入ACMED";
  },
  beforeDestroy() { },
  methods: {
    goToUpload() {
      window.location.href = 'https://member.cmea.org.cn/'
    },
    back() {
      this.$router.go(-1);
    }
  },
};
</script>

<style lang="scss" scoped>
.page {
  width: 100%;
  height: 100%;
  position: relative;
  background: rgb(247, 249, 253);
}

.totle {
  position: absolute;
  top: 45%;
  transform: translateY(-50%);
}

.maintitle {
  margin: auto;
  text-align: center;
  font-size: 25px;
  font-weight: bold;
  margin-bottom: 1rem;
}

.okqrcode {
  display: block;
  margin: auto;
  width: 70%;
  margin-top: 1rem;
}

.okqrcode1 {
  display: block;
  margin: auto;
  width: 55%;
  margin-top: 1rem;
}

.maininner {
  width: 73%;
  margin: auto;
  font-size: 20px;
}

.topimg {
  width: 100%;
  height: 100%;
  display: block;
}

.titletext {
  text-align: center;
  font-size: .6rem;
  font-weight: bold;
  color: rgb(32, 44, 87);
}

.titlebtn {
  width: 37%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 10px;
  padding: .4rem 0.1rem;
  justify-content: center;
  background: rgb(180, 45, 40);
  color: #fff;
  margin: 0.5rem auto;
}

.btnicon {
  display: block;
  width: 100%;
}

.iconout {
  width: 26%;
  padding-right: 0.2rem;
}

.btntext {
  font-size: .35rem;
}

.backbtn {
  position: absolute;
  right: 5%;
  top: 50%;
  transform: translateY(-50%);
  color: #829dcb;
  font-weight: bold;
  width: 1.2rem;
  text-align: center;
  height: 1.2rem;
  border-radius: 50rem;
  /* border: 1px solid #162e69; */
  line-height: 1.2rem;
  background: linear-gradient(40deg, #acd0eb, #f0f6fb);
}
</style>